import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { Update } from 'modules/contracts/components/ContractHistory/ContractVersionUpdate'
import getFieldKey from 'modules/contracts/lib/getFieldKey'

import * as styles from '../_Content/index.vanilla.css'

type CardRowProps = {
  update: Update
}

const formatValue = (value: string | number | Date | null | undefined) => {
  return value?.toString() || ''
}

const NonDetailedField = ({ update }: CardRowProps) => {
  const title = getFieldKey(update.key)

  return (
    <>
      <Box flexDirection="row" gap="s8" paddingTop="s8">
        <Text size="200">{title}:</Text>
        <Text size="200" weight="bold">
          {i18n.t('contract_versions.approval_page.promotion.card_info.changed')}
        </Text>
      </Box>
    </>
  )
}

const RegularDetailedField = ({ update }: CardRowProps) => {
  const before = formatValue(update.previousValue)
  const after = formatValue(update.currentValue)
  const title = getFieldKey(update.key)

  return (
    <>
      <Text size="200">{title}</Text>
      <Box className={styles.field} flexDirection="row" gap="s12">
        <Box className={styles.before}>{before}</Box>
        <Box className={styles.after} flexDirection="row" alignItems="center">
          <Icon.Small icon="arrow-right" color="grey700" /> {after}
        </Box>
      </Box>
    </>
  )
}

const RemovedAdditionalCompensation = ({ update }: CardRowProps) => {
  const value = formatValue(update.previousValue)
  const title = getFieldKey(update.key)
  return (
    <>
      <Text size="200">{title}</Text>
      <Box className={styles.field} flexDirection="row" gap="s12">
        <Box className={styles.onlyValue} flexDirection="row" alignItems="center">
          {value}
        </Box>
      </Box>
    </>
  )
}

const NewAdditionalCompensation = ({ update }: CardRowProps) => {
  const value = formatValue(update.currentValue)
  const title = getFieldKey(update.key)
  return (
    <>
      <Text size="200">{title}</Text>
      <Box className={styles.field} flexDirection="row" gap="s12">
        <Box className={styles.onlyValue} flexDirection="row" alignItems="center">
          {value}
        </Box>
      </Box>
    </>
  )
}

const CardRow = ({ update }: CardRowProps) => {
  const isNewAdditionalCompensation = update.key === 'new_additional_compensation'
  const isDeleteAdditionalCompensation = update.key === 'deleted_additional_compensation'
  const isAdditionalCompensationChange =
    isNewAdditionalCompensation || isDeleteAdditionalCompensation
  const isDetailedChange =
    !isAdditionalCompensationChange && (update.currentValue || update.previousValue)
  const isNonDetailedChange = !isAdditionalCompensationChange && !isDetailedChange

  return (
    <Box gap="s8">
      {isNewAdditionalCompensation && <NewAdditionalCompensation update={update} />}
      {isDeleteAdditionalCompensation && <RemovedAdditionalCompensation update={update} />}
      {isDetailedChange && <RegularDetailedField update={update} />}
      {isNonDetailedChange && <NonDetailedField update={update} />}
    </Box>
  )
}

export default observer(CardRow)
